import API from 'util/API';

export const findUsers = async () => await API.find('users/');

export const findUser = async (userId) => await API.find(`users/${userId}`);

export const getUser = async () => await API.find('users/me');

export const saveUser = async (user) => await API.save('users/', user);

export const validateUniqueUsername = async (username, userId) => {
  if (!username) {
    return 'Username is required';
  } else if (await API.find('users/validateUniqueUsername', {username, userId})) {
    return 'Username already exists';
  } else {
    return '';
  }
};

export const validateUniqueEmail = async (email, userId) => {
  const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

  if (!email) {
    return 'Email is required';
  } else if (!regex.exec(email)) {
    // If email doesnt fit regex pattern
    return 'Invalid email format';
  } else if (await API.find('users/validateUniqueEmail', {email, userId})) {
    return 'Email already exists';
  } else {
    return '';
  }
};

export const getQuickSightSignInToken = async () =>
  await API.find('quickSight/getQuickSightSignInToken');
